import { Component, OnInit } from '@angular/core';
declare var $:any;
declare var doCall: any;
declare var transferCall: any;
declare var init_page: any;
declare var getinStatusV2: any;
declare var iziToast:any;
declare var outgoingCallEnd:any;
declare var makecallTransfer:any;
declare var makecallTransfer2:any;
declare var doCall3:any;
import * as Feather from 'feather-icons';
@Component({
  selector: 'app-footer-helpdesk',
  templateUrl: './footer-helpdesk.component.html',
  styleUrls: ['./footer-helpdesk.component.css']
})

export class FooterHelpdeskComponent implements OnInit {
closes= 1;
sip_login;
  constructor() { }

  ngOnInit(): void {

// var sipLogin = '000';
// var sipauthenticationName = '3YAEcao70l';
// var sippassword = 'htfsfXhi8n';
// var sipOptions = {
// 	login: sipLogin,
// 	authenticationName: sipauthenticationName,
// 	password: sippassword,
// 	domain: 'cal4care.3cx.sg',
// 	outboundProxy: 'cal4care.3cx.sg',
// 	port: '5060'
// };

	$('#sip_urld').val("cal4care.3cx.sg");
	$('#server').val("sip:cal4care.3cx.sg:5060");
	$('#username').val("sip:000@cal4care.3cx.sg");
	$('#authuser').val("kwAePd1sln");
	$('#password').val("GjSEklDyx0");
	$('#displayname').val('devomni Channel');
  setTimeout( () => { init_page("sip:000@cal4care.3cx.sg","kwAePd1sln","GjSEklDyx0","sip:cal4care.3cx.sg:5060","5060");  }, 3000 );
  
	// $('#sip_urld').val("cal4care.3cx.sg");
	// $('#server').val("sip:cal4care.3cx.sg:5060");
	// $('#username').val("sip:602@cal4care.3cx.sg");
	// $('#authuser').val("h8EknaWYNk");
	// $('#password').val("PRsRim141d");
	// $('#displayname').val('devomni Channel');
	// setTimeout( () => { init_page("sip:602@cal4care.3cx.sg","h8EknaWYNk","PRsRim141d","sip:cal4care.3cx.sg:5060","5060");  }, 3000 );
  }


closefunctions(){
	if(this.closes == 1){
	$('.footer-help-desk').css('display','block');
	this.closes = 0;
	}else{
	$('.footer-help-desk').css('display','none');
	this.closes = 1;
	}
}

ngAfterViewInit() {
    Feather.replace();
  }

webMakeCall(number_key){
	$('#make_call_number').val(number_key);       
	doCall3('',number_key);
	$('.list-group li').click(function() {
        $(this).addClass('show').siblings().removeClass('show');
		$('.footer-click-to-call').addClass('show-btn');
		
    });
}


outgoingCallEnd() {
    outgoingCallEnd();
    $("#makecallHanupBtn").click();
    $('#makeCallForwordNumber').val('');
	$('.list-group li').removeClass('show');
	$('.footer-click-to-call').removeClass('show-btn');
}





}
